import { render, staticRenderFns } from "./TabThickness.vue?vue&type=template&id=d99f17fa&"
import script from "./TabThickness.vue?vue&type=script&lang=ts&"
export * from "./TabThickness.vue?vue&type=script&lang=ts&"
import style0 from "./TabThickness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports